import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const SECTIONS = {
  privacidad: [
    { h: "Datos que recopilamos", p: "Recopilamos nombre, correo, teléfono y dirección únicamente para procesar y entregar tu pedido. Los pagos se procesan directamente en Stripe; nunca almacenamos datos de tu tarjeta." },
    { h: "Uso de la información", p: "Usamos tus datos para preparar tu pedido, contactarte sobre su estado y, si lo autorizas, enviarte promociones. No vendemos ni compartimos tu información con terceros ajenos a la entrega." },
  ],
  terminos: [
    { h: "Productos", p: "Nuestras salsas son artesanales: el color y la textura pueden variar ligeramente entre tandas. Las fotografías son ilustrativas del producto real." },
    { h: "Precios y disponibilidad", p: "Los precios están en pesos mexicanos (MXN) e incluyen IVA. El stock mostrado puede variar; si un producto se agota tras tu compra, te contactamos para sustituirlo o reembolsarlo." },
    { h: "Pedidos", p: "Un pedido se confirma al completar el pago. Nos reservamos el derecho de cancelar pedidos con datos incorrectos, con reembolso completo." },
  ],
  envios: [
    { h: "Envío a domicilio", p: "$60 MXN en Mérida (local), con entregas de lunes a jueves de 7:00 p.m. a 10:00 p.m., y $350 MXN al resto de México (nacional) por paquetería. Preparamos tu pedido en 1-3 días hábiles (tandas artesanales)." },
    { h: "Pick up", p: "Sin costo en Fraccionamiento Las Américas 2, Mérida, de lunes a jueves de 4:00 p.m. a 7:00 p.m., con cita previa que agendamos por WhatsApp cuando tu pedido esté listo." },
    { h: "Devoluciones", p: "Si un frasco llega dañado o tu pedido viene incompleto, repónemos sin costo reportándolo con foto dentro de 48 horas. No aceptamos devoluciones de productos abiertos por razones de higiene." },
  ],
};

export default function Politicas() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-8" data-testid="politicas-page">
      <p className="text-center font-script font-semibold text-3xl text-orange">Las reglas del juego</p>
      <h1 className="mt-2 text-center font-script text-4xl font-semibold text-cocoa sm:text-5xl">Políticas</h1>
      <Tabs defaultValue="privacidad" className="mt-12">
        <TabsList className="grid w-full grid-cols-3 bg-surface">
          <TabsTrigger value="privacidad" data-testid="tab-privacidad">Privacidad</TabsTrigger>
          <TabsTrigger value="terminos" data-testid="tab-terminos">Términos</TabsTrigger>
          <TabsTrigger value="envios" data-testid="tab-envios">Envíos y devoluciones</TabsTrigger>
        </TabsList>
        {Object.entries(SECTIONS).map(([key, items]) => (
          <TabsContent key={key} value={key} className="mt-8 space-y-6">
            {items.map((s) => (
              <div key={s.h} className="rounded-2xl border border-sand bg-white p-6">
                <h2 className="font-script text-xl font-semibold text-cocoa">{s.h}</h2>
                <p className="mt-2 leading-relaxed text-clay">{s.p}</p>
              </div>
            ))}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
